import { f as r } from "./function-uncurry-this.js";
import { t } from "./to-object.js";
var o = r({}.hasOwnProperty),
  n = Object.hasOwn || function (r, n) {
    return o(t(r), n);
  };
export { n as h };